export default __webpack_public_path__ + "static/media/DISTRIBUCION_ITEM_ICON_6.23c83242.svg";